const styles = theme => ({
  notFoundContainer: {
    width: "100%",
    height: "100vh"
  },
  logoContainer: {
    maxWidth: "300px",
    padding: theme.spacing(4)
  },
  logo: {
    width: "200px "
  },
  textContainer: {
    textAlign: "center"
  },
  notFoundNumbers: {
    marginTop: theme.spacing(8),
    fontSize: "150px",
    color: theme.palette.primary.default,
    [theme.breakpoints.down("md")]: {
      fontSize: "100px"
    }
  },

  notFoundText: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(5),
    color: theme.palette.primary.default
  },
  backButton: {
    backgroundColor: theme.palette.primary.default,
    "&:hover": {
      backgroundColor: theme.palette.primary.default
    },
    color: "#fff"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/NotFound/styles.js